// extracted by mini-css-extract-plugin
export default {"typeCol":"SocialLeavesTable_typeCol__umGq-","tooltip__popper":"SocialLeavesTable_tooltip__popper__ESrkP","tooltip__root":"SocialLeavesTable_tooltip__root__jcJfc"};